export const CurrencyMap = {
  default: '₹',
  USD: '$',
  INR: '₹',
};
